import React from "react";
import { Route, Navigate, useLocation, Outlet } from "react-router-dom";
import Cookies from "universal-cookie";
import { authMiddleware } from './utils/authMiddleware.js';
import { frontEndLogs } from "./action/logs/frontEndLogs.js";

const PrivateRoute: React.FC<{
    component: React.FC;
    path: string;
}> = (props) => {
        
    const condition = authMiddleware();
    const location = useLocation();
    const cookie = new Cookies();
    //Removed the Skip Login Checks

    let routeLinks=[
        '/favorite-partner',
        '/wallet',
        '/wallet-contract-detail',
        '/viewed-partner',
        '/my-account',
        '/home',
        '/shop','/application','/quote-calculator','/quote-calculator-results', '/mobile-verification'];

    

    setTimeout(() => {
        if(sessionStorage.getItem('storeID') !== '' && sessionStorage.getItem('storeID') != null){
            cookie.set('retailerId',sessionStorage.getItem('storeID'),{ path: '/' });

            if((props.path === '/application' && location.pathname == '/application') && cookie.get('retailerId') !== undefined ){
                frontEndLogs('Received retailer id is saved in website - '+cookie.get('retailerId'),false,200, 'privateRoute');
            }
            else if(props.path === '/application' && location.pathname == '/application') {
                frontEndLogs('Received retailer id is not saved in website - '+cookie.get('retailerId'),false,200, 'privateRoute');
            }
        }
    }, 1400);
    
    
    if(!routeLinks.includes(location.pathname)){
        return (<Navigate to="/page-not-found" />);
    }  

    const isAdmin = localStorage.getItem("userRole") === "admin" && localStorage.getItem("admin_otp_verified") === "true";
    const adminUserView = sessionStorage.getItem("adminUserView");

    if (isAdmin && !adminUserView) {
        return condition ? <Navigate to="/admin-dashboard" /> : <Navigate to="/login" />;
    }

    if (isAdmin && adminUserView) {
        const actorId = sessionStorage.getItem("actor");
        if (!actorId) {
            sessionStorage.removeItem("adminUserView");
            sessionStorage.removeItem("actor_email");
            return <Navigate to="/login" />;
        }
    }

    let routeBlockApplyNow = [
        '/favorite-partner',
        '/wallet',
        '/wallet-contract-detail',
        '/viewed-partner',
        '/my-account',
        '/home',
        '/shop', '/mobile-verification'
    ];

    const routeCondition = condition ? (<Outlet />) : (<Navigate to="/login" />)

    const applyFlowRedirection = (routeBlockApplyNow.includes(location.pathname) && (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now')) ? <Navigate to="/login" /> : routeCondition


    return applyFlowRedirection;
};
export default PrivateRoute;